import { formatters } from '@utils/formattersV2';
import { SplineChartWithHeader } from '../../../../../../components/Summary/SplineChartWithHeader';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { reportsToSeriesData } from '../../../../utils';

type ImpressionsSplineChartProps = {
  reports: Lci3Report[];
};

export const ImpressionsSplineChart = (props: ImpressionsSplineChartProps) => {
  const impressionsSplineData = reportsToSeriesData({
    reports: props.reports,
    type: 'visit',
    field: 'impressions',
  });

  return (
    <SplineChartWithHeader
      title="Impressions"
      data={impressionsSplineData}
      color={unifiedPlatformColorPalette.chartLightGreen}
      formatter={value => formatters.impressions(value, { full: true })}
      yAxisLabelFormatter={formatters.number}
      differenceType="standard"
      data-testid="impressions-chart"
    />
  );
};
